import PropTypes from 'prop-types';
import React from 'react';
export default function PlusSmall(_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, height: "10", viewBox: "0 0 10 10", width: "10" },
        React.createElement("path", { d: "M4,4H1A1,1,0,0,0,1,6H4V9A1,1,0,0,0,6,9V6H9A1,1,0,0,0,9,4H6V1A1,1,0,0,0,4,1Z" })));
}
PlusSmall.propTypes = {
    className: PropTypes.node,
};
PlusSmall.defaultProps = {
    className: 'display-block',
};
